"use client"
import Link from "next/link"
import { Button } from "@/components/ui/button"
import { LogOut, User } from "lucide-react"
import { useAuth } from "@/hooks/use-auth"
import { ThemeToggle } from "@/components/ui/theme-toggle"
import { Logo } from "@/components/ui/logo"

export function Header() {
  const { isAuthenticated, user, session, signOut, isLoading } = useAuth()

  if (isLoading) {
    return (
      <header className="bg-background border-b border-border px-6 py-4">
        <div className="flex items-center justify-between">
          <Link href="/" className="flex items-center space-x-3">
            <Logo size={40} className="flex-shrink-0" />
            <h1 className="text-2xl font-semibold text-foreground">DLOM & Blockage Calculator</h1>
          </Link>
          <div className="flex items-center space-x-4">
            <ThemeToggle />
          </div>
        </div>
      </header>
    )
  }

  return (
    <header className="bg-background border-b border-border px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <Link href="/" className="flex items-center space-x-3">
            <Logo size={40} className="flex-shrink-0" />
            <h1 className="text-2xl font-semibold text-foreground">DLOM & Blockage Calculator</h1>
          </Link>
        </div>

        <nav className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <ThemeToggle />
          </div>
          
          {isAuthenticated ? (
            <div className="flex items-center space-x-3">
              <div className="flex items-center space-x-2 text-sm text-muted-foreground">
                <User className="h-4 w-4" />
                <span>{session?.tokens?.idToken?.payload?.email || user?.username}</span>
              </div>
              <Button onClick={signOut} variant="outline" size="sm" className="font-normal">
                <LogOut className="h-4 w-4 mr-2" />
                Sign out
              </Button>
            </div>
          ) : (
            <div className="flex items-center space-x-2">
              <Button asChild variant="outline" size="sm">
                <a href="/signin">Sign In</a>
              </Button>
              <Button asChild size="sm">
                <a href="/signup">Sign Up</a>
              </Button>
            </div>
          )}
        </nav>
      </div>
    </header>
  )
}
